import { COURSE_STATUS } from '@/constants/course-status'
import type { CourseEquivalenceFormType } from '@/schemas/education/match-courses-schema'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import type { SelectSerieItem } from '../components/select-serie'

export function useTranscriptSerie() {
  function createSerieOptions(
    courses: DesiredEducationCourse[] | undefined
  ): SelectSerieItem[] {
    const seriesSet = new Set<string>()
    courses?.forEach((course) => {
      seriesSet.add(String(course.serie))
    })
    return Array.from(seriesSet).map((serie) => ({
      label: serie,
      id: serie
    }))
  }

  function determineStudentSerie(
    equivalences: CourseEquivalenceFormType,
    courses: DesiredEducationCourse[]
  ) {
    let bestSerie: string | null = null

    const map = new Map<number, number>()

    equivalences?.forEach((equivalence) => {
      const course = courses?.find(
        (course) => course.courseId === equivalence.desiredCourse.courseId
      )

      if (course?.serie) {
        if (!map.has(Number(course.serie))) {
          map.set(Number(course.serie), 0)
        }

        const value = map.get(Number(course?.serie))

        if (
          equivalence.equivalenceStatus
          && equivalence.equivalenceStatus.id === COURSE_STATUS.GRANT.id
          && value !== undefined
        ) {
          map.set(Number(course.serie), value + 1)
        }
      }
    })

    const sortedByKey = new Map([...map.entries()].sort((a, b) => a[0] - b[0]))
    for (const [key, value] of sortedByKey) {
      if (value >= 2) {
        bestSerie = String(key)
        break
      }
    }

    return bestSerie
  }

  return { actions: { determineStudentSerie, createSerieOptions } }
}
